/**
 * 安全监测示例数据及公共方法
 * 说明：安全监测接口暂为示例假路径，安全监测列表页（dev_data/safety_monitoring.vue）
 *      与运营大屏（data_screen/index.vue）共用本文件的示例数据，保证两个界面的
 *      统计次数、异常名称、详细地址、异常时间完全一致；后端接口就绪后可移除本文件。
 */

/* ================= 示例设备 ================= */
const MOCK_DEVICES = [
  {
    dev_name: "麓谷科技园1号台区",
    dev_type: "power_transformer",
    asset_code: "430104000100000101",
    site_name: "麓谷科技园充电站",
    address: "长沙市岳麓区麓谷大道658号麓谷科技园A区配电房",
    channels: []
  },
  {
    dev_name: "麓谷科技园2号台区",
    dev_type: "power_transformer",
    asset_code: "430104000100000102",
    site_name: "麓谷科技园充电站",
    address: "长沙市岳麓区麓谷大道658号麓谷科技园B区配电房",
    channels: []
  },
  {
    dev_name: "万家丽广场1号一体柜",
    dev_type: "power_cabinet",
    asset_code: "430102000200000201",
    site_name: "万家丽广场充电站",
    address: "长沙市芙蓉区万家丽中路一段99号万家丽广场B2层",
    channels: [1, 2, 3, 4]
  },
  {
    dev_name: "万家丽广场2号一体柜",
    dev_type: "power_cabinet",
    asset_code: "430102000200000202",
    site_name: "万家丽广场充电站",
    address: "长沙市芙蓉区万家丽中路一段99号万家丽广场B3层",
    channels: [1, 2, 3, 4]
  },
  {
    dev_name: "北辰三角洲A区分支箱",
    dev_type: "power_branch_box",
    asset_code: "430105000300000301",
    site_name: "北辰三角洲充电站",
    address: "长沙市开福区湘江中路一段288号北辰三角洲A区",
    channels: [1, 2, 3, 4, 5, 6]
  },
  {
    dev_name: "北辰三角洲B区分支箱",
    dev_type: "power_branch_box",
    asset_code: "430105000300000302",
    site_name: "北辰三角洲充电站",
    address: "长沙市开福区湘江中路一段288号北辰三角洲B区",
    channels: [1, 2, 3, 4]
  },
  {
    dev_name: "德思勤广场1号充电桩",
    dev_type: "power_charge_pile",
    asset_code: "430111000400000401",
    site_name: "德思勤广场充电站",
    address: "长沙市雨花区韶山南路118号德思勤城市广场P2停车场",
    channels: [1]
  },
  {
    dev_name: "德思勤广场2号充电桩",
    dev_type: "power_charge_pile",
    asset_code: "430111000400000402",
    site_name: "德思勤广场充电站",
    address: "长沙市雨花区韶山南路118号德思勤城市广场P3停车场",
    channels: [1, 2]
  },
  {
    dev_name: "清水塘公交站1号一体柜",
    dev_type: "power_cabinet",
    asset_code: "430202000200000205",
    site_name: "清水塘公交充电站",
    address: "株洲市天元区黄河北路128号清水塘公交充电站",
    channels: [1, 2, 3, 4, 5, 6]
  },
  {
    dev_name: "楠竹山充电站1号分支箱",
    dev_type: "power_branch_box",
    asset_code: "430302000300000305",
    site_name: "楠竹山充电站",
    address: "湘潭市雨湖区楠竹山镇建设路36号楠竹山充电站",
    channels: [1, 2, 3]
  },
  {
    dev_name: "船山广场1号充电桩",
    dev_type: "power_charge_pile",
    asset_code: "430405000400000407",
    site_name: "船山广场充电站",
    address: "衡阳市蒸湘区船山大道66号船山广场地下停车场",
    channels: []
  },
  {
    dev_name: "岳阳东站1号台区",
    dev_type: "power_transformer",
    asset_code: "430602000100000108",
    site_name: "岳阳东站充电站",
    address: "岳阳市岳阳楼区洞庭大道218号岳阳东站西广场",
    channels: []
  }
]

/* ================= 异常模板 =================
 * alarm_type：1 预警，2 报警
 */
const MOCK_ALARM_TEMPLATES = [
  { alarm_name: "过温告警", alarm_type: 2, alarm_code: "ALARM_TEMP_OVER", alarm_detail: "设备运行温度超过报警阈值，已触发降功率保护", alarm_num: 3 },
  { alarm_name: "通信中断", alarm_type: 1, alarm_code: "WARN_COMM_DELAY", alarm_detail: "通信心跳延迟超过30秒，存在离线风险", alarm_num: 1 },
  { alarm_name: "直流母线绝缘异常", alarm_type: 2, alarm_code: "ALARM_INSULATION", alarm_detail: "直流母线绝缘阻值低于安全阈值（当前0.6MΩ）", alarm_num: 2 },
  { alarm_name: "过压告警", alarm_type: 1, alarm_code: "WARN_VOLT_HIGH", alarm_detail: "进线电压偏高（当前242V，额定220V）", alarm_num: 2 },
  { alarm_name: "枪锁异常", alarm_type: 1, alarm_code: "WARN_GUN_LOCK", alarm_detail: "充电枪电子锁未正常吸合，请检查枪锁状态", alarm_num: 1 },
  { alarm_name: "计量异常", alarm_type: 1, alarm_code: "WARN_METER_ABNORMAL", alarm_detail: "计量模块读数跳变，疑似计量异常", alarm_num: 1 },
  { alarm_name: "过流保护", alarm_type: 2, alarm_code: "ALARM_OVER_CURRENT", alarm_detail: "输出电流超过额定值，保护动作已断开回路", alarm_num: 4 },
  { alarm_name: "漏电保护", alarm_type: 2, alarm_code: "ALARM_LEAK_CURRENT", alarm_detail: "漏电流超过保护阈值（当前32mA，阈值30mA）", alarm_num: 2 },
  { alarm_name: "急停触发", alarm_type: 2, alarm_code: "ALARM_EMERGENCY_STOP", alarm_detail: "急停按钮被触发，设备已停止输出", alarm_num: 1 },
  { alarm_name: "欠压告警", alarm_type: 1, alarm_code: "WARN_VOLT_LOW", alarm_detail: "进线电压偏低（当前198V，额定220V）", alarm_num: 2 }
]

// 示例数据中「监测正常次数」基数（预警/报警次数取示例异常记录条数）
const MOCK_NORMAL_NUM = 1286400

function padZero(num) {
  return num < 10 ? "0" + num : String(num)
}

function formatMockTime(offsetMinutes) {
  const base = new Date(2026, 10, 3, 10, 20, 0)
  const target = new Date(base.getTime() - offsetMinutes * 60 * 1000)
  const date = [target.getFullYear(), padZero(target.getMonth() + 1), padZero(target.getDate())].join("-")
  const time = [padZero(target.getHours()), padZero(target.getMinutes()), padZero(target.getSeconds())].join(":")
  return date + " " + time
}

const MOCK_ABNORMAL_LIST = (() => {
  const list = []
  const count = 32
  for (let i = 0; i < count; i++) {
    const dev = MOCK_DEVICES[i % MOCK_DEVICES.length]
    const alarm = MOCK_ALARM_TEMPLATES[i % MOCK_ALARM_TEMPLATES.length]
    const channels = dev.channels || []
    list.push({
      id: i + 1,
      dev_name: dev.dev_name,
      dev_type: dev.dev_type,
      asset_code: dev.asset_code,
      site_name: dev.site_name,
      address: dev.address,
      // 无通道的设备返回空，界面展示为「无」
      channel: channels.length ? channels[i % channels.length] : null,
      alarm_name: alarm.alarm_name,
      alarm_type: alarm.alarm_type,
      alarm_code: alarm.alarm_code,
      alarm_detail: alarm.alarm_detail,
      alarm_num: alarm.alarm_num + (i % 3),
      alarm_time: formatMockTime(i * 37 + (i % 5) * 3)
    })
  }
  return list.sort((a, b) => (a.alarm_time < b.alarm_time ? 1 : -1))
})()

/**
 * 安全监测示例统计数据 + 异常明细（列表页与大屏共用）
 * normal_num：监测正常次数；warn_num：监测预警次数；alarm_num：监测报警次数
 */
export const SAFETY_MONITOR_MOCK = {
  normal_num: MOCK_NORMAL_NUM,
  warn_num: MOCK_ABNORMAL_LIST.filter((item) => Number(item.alarm_type) === 1).length,
  alarm_num: MOCK_ABNORMAL_LIST.filter((item) => Number(item.alarm_type) === 2).length,
  list: MOCK_ABNORMAL_LIST
}

/**
 * 异常率格式化：按数值大小自动切换百分号 / 千分号 / 万分号
 * 异常率 =（预警次数 + 报警次数）/（正常次数 + 预警次数 + 报警次数）
 * @param {number} warnNum 预警次数
 * @param {number} alarmNum 报警次数
 * @param {number} normalNum 正常次数
 * @returns {{ value: string, unit: string, percent: number }} value 展示值，unit 单位，percent 百分比原始值
 */
export function formatAbnormalRate(warnNum, alarmNum, normalNum) {
  const warn = Number(warnNum) || 0
  const alarm = Number(alarmNum) || 0
  const normal = Number(normalNum) || 0
  const total = warn + alarm + normal
  if (!total) return { value: "0.00", unit: "%", percent: 0 }

  const percent = ((warn + alarm) / total) * 100
  // ≥1% 使用百分号；≥0.01%（即 0.1‰）使用千分号；更小使用万分号
  if (percent >= 1) return { value: percent.toFixed(2), unit: "%", percent }
  if (percent >= 0.01) return { value: (percent * 10).toFixed(2), unit: "‰", percent }
  return { value: (percent * 100).toFixed(2), unit: "‱", percent }
}
